import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Box, Typography } from '@mui/material';
import { aiGradientTextSx } from 'common/constants/ai';

interface CitationBodyProps {
  confidence?: number | null;
  plainTexts?: string[];
  documentName?: string;
  sectionLabel?: string;
}

const CitationBody = ({ confidence, plainTexts = [], documentName, sectionLabel }: CitationBodyProps) => (
  <>
    {/* Header row: label left, confidence right */}
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      {sectionLabel && (
        <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.8rem' }}>
          {sectionLabel}
        </Typography>
      )}
      {confidence != null && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.78rem' }}>
            Confidence:
          </Typography>
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, fontSize: '0.78rem', ...(aiGradientTextSx as Record<string, unknown>) }}>
            {Math.round(confidence * 100)}%
          </Typography>
        </Box>
      )}
    </Box>

    {/* Citation plain texts with horizontal margin */}
    {plainTexts.length > 0 && (
      <Box sx={{ mx: 1.5, mt: 0.5 }}>
        {plainTexts.map((text, index) => (
          <Typography
            key={index}
            variant="body2"
            color="text.secondary"
            sx={{ fontStyle: 'italic', mb: index < plainTexts.length - 1 ? 0.5 : 0 }}>
            {text}
          </Typography>
        ))}
      </Box>
    )}

    {/* Document name with file icon */}
    {documentName && (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
        <DescriptionOutlinedIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
        <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.78rem' }}>
          {documentName}
        </Typography>
      </Box>
    )}
  </>
);

export default CitationBody;
